import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { UnauthorizedError } from '@ember-data/adapter/error';
import { pluralize } from 'ember-inflector';
import { underscore } from '@ember/string';
import { inject } from '@ember/service';
import { notifyUserError } from 'beebee-base/lib/utility';
import getConfig from 'beebee-base/lib/get-config';

var _class, _descriptor, _descriptor2, _descriptor3;
let ApplicationAdapter = (_class = class ApplicationAdapter extends JSONAPIAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "notify", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    this.namespace = 'v1';
  }
  get host() {
    let domain = location.hostname.split('.').shift();
    const defaultHost = window.location.host;
    domain = domain ? `${domain}.beebeeboard.com` : defaultHost;
    return getConfig(this).environment === 'production' ? `https://${domain}/api` : getConfig(this).APP.host;
  }
  pathForType(type) {
    return pluralize(underscore(type));
  }
  get headers() {
    return this.session.token ? {
      Authorization: `Bearer ${this.session.token}`
    } : {};
  }
  handleResponse(status, headers, body, requestData) {
    if (status >= 200 && status < 300) {
      if (!body) {
        return null;
      }
      return super.handleResponse(status, headers, body, requestData);
    } else if (status === 401) {
      return this._handleUnauthorized();
    } else {
      if (body) {
        notifyUserError(this.notify, body, this.intl);
      }
      return super.handleResponse(status, headers, body, requestData);
    }
  }
  _handleUnauthorized() {
    // Reload only to drop a session the server refused. Without a token there is nothing to drop and a reload
    // cannot help: in development redirectToLogin shows the dev login and lets the route go on, so its model
    // request answers 401 again and the page reloaded forever, never showing the login.
    if (!this.session.allowAnonymous && this.session.token) {
      // One 401 policy for Ember Data and the ajax helpers (Intercom P31/P32): the session raises the lock in
      // place (the page and the unsaved text stay) and falls back to the login page with a return URL. A
      // session service without that hook (older apps) keeps the old logout + reload.
      if (typeof this.session.handleUnauthorized === 'function') {
        this.session.handleUnauthorized();
      } else {
        this.session.logout();
        window.location.reload();
      }
    }
    return new UnauthorizedError();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ApplicationAdapter as default };
//# sourceMappingURL=application.js.map
